export class DailyStorageSummaries {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "data",
            "baseName": "data",
            "type": "Array<DailyStorageSummary>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return DailyStorageSummaries.attributeTypeMap;
    }
    constructor() {
    }
}
